import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import {
  getBlocks as getBlocksApi,
  addNewBlock as addNewBlockApi,
  updateBlock as updateBlockApi,
  deleteBlock as deleteBlockApi,
  getBlockById as getBlockByIdApi,
  getBlockUnitsById as getBlockUnitsByIdApi,
} from "../../helpers/fakebackend_helper";

export const getBlocks = createAsyncThunk("blocks", async () => {
  try {
    const response = await getBlocksApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const getBlockById = createAsyncThunk(
  "blocks/getBlockById",
  async (id) => {
    try {
      const response = await getBlockByIdApi(id); // Call the API to get a single block by ID
      return response;
    } catch (error) {
      toast.error("Failed to fetch block by ID", { autoClose: 1000 });
      throw error;
    }
  }
);

export const getBlockUnitsById = createAsyncThunk(
  "blocks/getBlockUnitsById",
  async (id) => {
    try {
      const response = await getBlockUnitsByIdApi(id); // Call the API to get a single block by ID
      return response;
    } catch (error) {
      toast.error("Failed to fetch block units by ID", { autoClose: 1000 });
      throw error;
    }
  }
);

export const addNewBlock = createAsyncThunk("blocks/addNewBlock", async ({ block }) => {
  try {
    const response = await addNewBlockApi(block);
    toast.success("Block Added Successfully", { autoClose: 1000 });
    return response;
  } catch (error) {
    toast.error("Faild to add Block", { autoClose: 1000 });
    return error;
  }
});

export const updateBlock = createAsyncThunk("blocks/updateBlock", async ({ block }) => {
  try {
    const response = await updateBlockApi(block);
    toast.success("Block Updated Successfully", { autoClose: 1000 });
    return response;
  } catch (error) {
    toast.error("Failed to update block", { autoClose: 1000 });
    return error;
  }
});

export const deleteBlock = createAsyncThunk("blocks/deleteBlock", async ({ blockId }) => {
  try {
    const response = await deleteBlockApi(blockId);
    toast.success("Block Deleted Successfully", { autoClose: 1000 });
    return { blockId, ...response };
  } catch (error) {
    toast.error("Failed to delete block", { autoClose: 1000 });
    return error;
  }
});
